// Centralized API URL configuration
// Handles both development and production (including custom domains)

export const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // If env URL is valid and contains proper domain, use it
  if (envUrl && envUrl.includes('://') && envUrl.includes('.')) {
    return `${envUrl}/api`;
  }
  
  // Fallback: use current origin (for custom domains like konusbuddy.com)
  // API calls will go to same domain with /api prefix
  return `${window.location.origin}/api`;
};

export const API = getApiUrl();
